export default "__VITE_ASSET__vkgfqn16__"